/*
 * custom-cart-sync.js — Lyro Digital, 17 Eyl 2026
 *
 * Sorun: Pumper Bundles (koli/çoklu paket) satırlarında Shopify, her adet
 * değişikliğinde satırın `key` değerini yeniliyor (otomatik indirim satıra
 * uygulandığı için). Tema (Arena) sepet çekmecesini ve sepet sayfasını
 * `data-item-key` eşleştirerek güncellediğinden eski key bulunamıyor:
 *   - Çekmece eski satırı silmeden yenisini üstüne ekliyor (10 + 20 = "30" görünüyor)
 *   - +/- sonrası fiyat güncellenmiyor, ikinci tıklamada eski key ile istek atılıp hata veriyor
 *
 * Çözüm: Sepeti değiştiren her istekten (/cart/add, change, update, clear) sonra
 * çekmeceyi ve sepet sayfasını sunucudan taze HTML ile yeniden çiziyoruz.
 * Tema dosyalarına dokunulmadı; kaldırmak için theme.liquid'deki script satırını silmek yeterli.
 */
(function () {
  'use strict';

  var DRAWER_ID = 'cartShopping';
  var CART_SECTION_ID = 'cart-template';
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var routes = (window.theme && window.theme.routes) || {};
  var rootUrl = routes.root_url && routes.root_url !== '/' ? routes.root_url.replace(/\/$/, '') : '';
  var searchUrl = routes.search_url || (rootUrl + '/search');
  var cartUrl = routes.cart_url || (rootUrl + '/cart');

  var nativeFetch = window.fetch;
  var timer = null;
  var syncing = false;
  var pending = false;

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 120);
  }

  function parse(html) {
    var doc = document.implementation.createHTMLDocument('');
    doc.body.innerHTML = html;
    return doc;
  }

  function setText(selector, value) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) nodes[i].innerHTML = value;
  }

  function syncDrawer() {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return Promise.resolve();

    return nativeFetch(searchUrl + '?view=include.cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = parse(html).getElementById(DRAWER_ID);
        if (!fresh) return;

        var body = drawer.querySelector('[data-cart-body]');
        var freshBody = fresh.querySelector('[data-cart-body]');
        if (body && freshBody) body.innerHTML = freshBody.innerHTML;

        var count = fresh.querySelector('[data-cart-count]');
        if (count) setText('[data-cart-count]', count.innerHTML);

        var total = fresh.querySelector('[data-cart-total]');
        if (total) setText('[data-cart-total]', total.innerHTML);

        var removeAll = drawer.querySelector('[data-cart-remove-all]');
        var freshRemoveAll = fresh.querySelector('[data-cart-remove-all]');
        if (removeAll && freshRemoveAll) removeAll.className = freshRemoveAll.className;

        var checkout = drawer.querySelector('button[name="checkout"]');
        var freshCheckout = fresh.querySelector('button[name="checkout"]');
        if (checkout && freshCheckout) {
          if (freshCheckout.disabled) checkout.setAttribute('disabled', 'disabled');
          else checkout.removeAttribute('disabled');
          checkout.classList.remove('hide');
        }
      });
  }

  function syncCartPage() {
    var section = document.getElementById('shopify-section-' + CART_SECTION_ID);
    if (!section) return Promise.resolve();

    return nativeFetch(cartUrl + '?section_id=' + CART_SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = parse(html).getElementById('shopify-section-' + CART_SECTION_ID);
        if (!fresh) return;

        // Sepet notunu koru: kullanıcı yazarken silinmesin
        var note = section.querySelector('textarea[name="note"]');
        var noteValue = note ? note.value : null;

        section.innerHTML = fresh.innerHTML;

        var freshNote = section.querySelector('textarea[name="note"]');
        if (freshNote && noteValue !== null) freshNote.value = noteValue;

        var count = section.querySelector('[data-cart-count]');
        if (count) setText('[data-cart-count]', count.innerHTML);
      });
  }

  function sync() {
    if (syncing) { pending = true; return; }
    syncing = true;
    Promise.all([syncDrawer(), syncCartPage()])
      .catch(function (e) { if (window.console) console.warn('cart-sync', e); })
      .then(function () {
        syncing = false;
        if (pending) { pending = false; scheduleSync(); }
      });
  }

  // 1) Sepeti değiştiren her fetch isteğinden sonra senkronla
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = nativeFetch.apply(this, arguments);
    if (CART_MUTATION.test(url)) {
      result.then(scheduleSync, function () {});
    }
    return result;
  };

  // 2) XMLHttpRequest ile sepet değiştiren uygulamalar için
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_MUTATION.test(url)) {
      this.addEventListener('loadend', scheduleSync);
    }
    return nativeOpen.apply(this, arguments);
  };

  // 3) Çekmece her açıldığında son bir kez senkronla (temanın araya eklediği satırları temizler)
  function watchDrawer() {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer || drawer.__cartSyncWatched) return;
    drawer.__cartSyncWatched = true;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (target.classList && target.classList.contains('is-open') && !target.__wasOpen) {
          target.__wasOpen = true;
          scheduleSync();
        } else if (target.classList && !target.classList.contains('is-open')) {
          target.__wasOpen = false;
        }
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  new MutationObserver(watchDrawer).observe(document.body, { childList: true });
  watchDrawer();
})();
